import React from 'react';
import { AgeChip } from './AgeChip.jsx';

/* Every chart, without exception, is wrapped in this frame. Title left, range
   selector right as TEXT buttons, a UTC/local note if the axis is temporal, and
   the legend BELOW the plot rather than floating in it. No chart animates, on
   load or on update. A stale chart renders at 50% opacity with an age chip in
   its title row. */

export function ChartFrame({
  title, ranges = ['1d', '7d', '30d', '1y', 'all'], range, onRange, timezone,
  legend = [], age, ageState = 'fresh', stale = false, height, children, style,
}) {
  return (
    <section style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-12)', ...style }}>
      <header style={{ display: 'flex', alignItems: 'baseline', gap: 'var(--space-12)' }}>
        <h3 style={{
          margin: 0, fontSize: 'var(--heading-size)', lineHeight: 'var(--heading-line)',
          fontWeight: 'var(--heading-weight)', color: 'var(--text-primary)',
        }}>{title}</h3>
        {age ? <AgeChip age={age} state={ageState} /> : null}
        {timezone ? <span style={{ fontSize: 'var(--caption-size)', color: 'var(--text-tertiary)' }}>times in {timezone}</span> : null}
        <span style={{ marginLeft: 'auto', display: 'flex', gap: 'var(--space-8)' }}>
          {ranges.map((r) => (
            <button key={r} type="button" onClick={() => onRange && onRange(r)} className="jmt-range"
              style={{
                background: 'none', border: 'none', padding: '2px 2px', cursor: 'pointer',
                fontFamily: 'var(--font-ui)', fontSize: 'var(--body-sm-size)',
                color: r === range ? 'var(--accent)' : 'var(--text-secondary)',
                fontWeight: r === range ? 500 : 400,
              }}>{r}</button>
          ))}
        </span>
      </header>

      <div style={{ height, opacity: stale ? .5 : 1 }}>{children}</div>

      {legend.length ? (
        <footer style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-16)' }}>
          {legend.map((l) => (
            <span key={l.label} style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--space-8)', fontSize: 'var(--caption-size)', color: 'var(--text-secondary)' }}>
              <span aria-hidden="true" style={{
                width: 14, height: 0,
                borderTop: (l.dashed ? '1px dashed ' : '1.5px solid ') + (l.colour || 'var(--accent)'),
              }} />
              {l.label}
            </span>
          ))}
        </footer>
      ) : null}
      <style>{`.jmt-range:hover{color:var(--text-primary)}.jmt-range:focus-visible{outline:none;box-shadow:var(--focus-ring)}`}</style>
    </section>
  );
}
